import { boolean, object, string } from 'yup';

const msgMinCharsName = 'Name is required for selected SIM.';
const msgMaxCharsName = 'Name must contain at most 20 characters.';
const msgMinCharsAPN = 'APN is required for selected SIM.';
const msgMaxCharsAPN = 'APN must contain at most 63 characters.';
const msgASCII = 'must contain only ASCII characters.';

const asciiRegex = /^[ -~]*$/;

export const simSchema = object().shape({
  selected: boolean(),
  name: string()
    .trim()
    .max(20, msgMaxCharsName)
    .matches(asciiRegex, `Name ${msgASCII}`)
    .when('selected', {
      is: true,
      then: (schema) => schema.required(msgMinCharsName),
      otherwise: (schema) => schema,
    }),
  apn: string()
    .trim()
    .max(63, msgMaxCharsAPN)
    .matches(asciiRegex, `APN ${msgASCII}`)
    .when('selected', {
      is: true,
      then: (schema) => schema.required(msgMinCharsAPN),
      otherwise: (schema) => schema,
    }),
});
